var _style, _g, _polygon, _polygon2, _polygon3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPieChart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    textRendering: "geometricPrecision",
    shapeRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 513.9",
    style: {
      enableBackground: "new 0 0 512 513.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#E1E1E1;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M255.9,513.9C114.8,513.9,0,399,0,257.9c0-45.1,11.8-87.6,32.5-124.6l76.9,44.4 c-13.1,23.9-20.6,51.1-20.6,80.2c0,92.2,75,167.2,167.1,167.2c29.2,0,56.5-7.4,80.3-20.6l44.4,76.9 C343.7,502.1,301.2,513.9,255.9,513.9z M32.5,133.3c1.3-2.2,2.5-4.4,3.8-6.6c1.1,1.5,1.5,3.2,0.7,4.8C36,133,34.4,133.4,32.5,133.3 z M36.3,126.7C80.4,53.1,160.6,3.4,252.2,2.1v88.7c-58.8,1.4-110.2,33.2-139,80.3L36.3,126.7z M342.9,400.8 c48.1-29.4,80.3-82.4,80.3-142.9c0-13.6-1.7-26.8-4.7-39.6l85.7-22.9c5.1,20,7.8,41,7.8,62.5c0,93.3-50.1,174.9-124.7,219.7 L342.9,400.8z M416.5,211c-20-68.3-82.4-118.6-156.6-120.2V2.1C375,3.7,472.1,81.9,502.2,188L416.5,211z"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "107.1,181.8 116.2,165.6 40.6,119.2 28.1,140.9 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "420.2,224.3 415.2,206.2 500.6,182.1 505.7,200.8 "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "332,407.1 346.2,398.9 390.8,475.5 377.1,483.6 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPieChart);
export default __webpack_public_path__ + "static/media/pie-chart.8c8ad09586fa183e330b16e9ed6b2789.svg";
export { ForwardRef as ReactComponent };